/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PageMedicalRequestDto } from '../model';
/**
 * AdminMedicalRequestControllerApi - axios parameter creator
 * @export
 */
export const AdminMedicalRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} requestId 
         * @param {number} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDoctorForPrescriptionRequest: async (requestId: number, doctorId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('changeDoctorForPrescriptionRequest', 'requestId', requestId)
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('changeDoctorForPrescriptionRequest', 'doctorId', doctorId)
            const localVarPath = `/api/admin/medical-request/{requestId}/change/{doctorId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)))
                .replace(`{${"doctorId"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [fromUserId] 
         * @param {number} [toUserId] 
         * @param {Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionRequests: async (fromUserId?: number, toUserId?: number, statuses?: Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/medical-request/prescription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromUserId !== undefined) {
                localVarQueryParameter['fromUserId'] = fromUserId;
            }

            if (toUserId !== undefined) {
                localVarQueryParameter['toUserId'] = toUserId;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMedicalRequestControllerApi - functional programming interface
 * @export
 */
export const AdminMedicalRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMedicalRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} requestId 
         * @param {number} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeDoctorForPrescriptionRequest(requestId: number, doctorId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeDoctorForPrescriptionRequest(requestId, doctorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [fromUserId] 
         * @param {number} [toUserId] 
         * @param {Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescriptionRequests(fromUserId?: number, toUserId?: number, statuses?: Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PageMedicalRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescriptionRequests(fromUserId, toUserId, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminMedicalRequestControllerApi - factory interface
 * @export
 */
export const AdminMedicalRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMedicalRequestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} requestId 
         * @param {number} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDoctorForPrescriptionRequest(requestId: number, doctorId: number, options?: any): Promise<void> {
            return localVarFp.changeDoctorForPrescriptionRequest(requestId, doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [fromUserId] 
         * @param {number} [toUserId] 
         * @param {Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionRequests(fromUserId?: number, toUserId?: number, statuses?: Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>, options?: any): Promise<PageMedicalRequestDto> {
            return localVarFp.getPrescriptionRequests(fromUserId, toUserId, statuses, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMedicalRequestControllerApi - object-oriented interface
 * @export
 * @class AdminMedicalRequestControllerApi
 * @extends {BaseAPI}
 */
export class AdminMedicalRequestControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} requestId 
     * @param {number} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMedicalRequestControllerApi
     */
    public changeDoctorForPrescriptionRequest(requestId: number, doctorId: number, options?: AxiosRequestConfig) {
        return AdminMedicalRequestControllerApiFp(this.configuration).changeDoctorForPrescriptionRequest(requestId, doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [fromUserId] 
     * @param {number} [toUserId] 
     * @param {Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMedicalRequestControllerApi
     */
    public getPrescriptionRequests(fromUserId?: number, toUserId?: number, statuses?: Array<'NEW' | 'ACCEPTED' | 'DONE' | 'REJECTED' | 'CANCELLED' | 'FORWARDED'>, options?: AxiosRequestConfig) {
        return AdminMedicalRequestControllerApiFp(this.configuration).getPrescriptionRequests(fromUserId, toUserId, statuses, options).then((request) => request(this.axios, this.basePath));
    }
}
